@if (store) {
<div class="flex flex-column bg-col-w z-10 w-12 p-b-7 p-t-3">
    <!-- image -->
    @if (store.data?.images?.length) {
    <div class="w-12 ratio-16-9">
        <img class="rf"
             [image]="store.data.images[0]">
    </div>
    }
    <!-- store name -->
    <span class="h4 p-t-7">{{store.data.store_name}}</span>
    <!-- open status-->
    <store-open-status class="p-t-2"
                       [store]="store"></store-open-status>
    <!-- see more store information-->
    @if (store.data.url || store.data.external_link) {
    <href class="p-t-2"
          [link]="store.url">
        <span class="p1 b-b b-col-1 p-b-1">
            {{'See more' | translate}} {{(isWarehouse ? 'warehouse' : 'store') | translate}} {{'information' |
            translate}}
        </span>
    </href>
    }
    <!-- Store details-->
    <div class="flex w-12 p-t-5 p-b-7 b-b w-12 b-b">
        <div class="flex flex-column flex-wrap p-r w-6">
            @if (store.data?.address) {
            <p class="p1 p-t-2 flex flex-wrap">{{store.data.address}}</p>
            }
            <p class="p1">{{store.data.city}}, {{store.data.postcode}}</p>
        </div>
        <div class="flex flex-column w-6">
            @if (store.data.phone) {
            <div class="pos-relative m-t-2">
                <a class="m-l-8 block"
                   [attr.href]="'tel:' + store.data.phone">
                    <i class="icon-phone pos-absolute top-50 left-0 p-l-1"
                       [style.font-size.rem]="1"></i>
                    <span class="p1">{{store.data.phone}}</span>
                </a>
            </div>
            }
            <!-- get direction -->
            <a class="w-12 m-t-2 flex flex-justify-between"
               [attr.href]="store.directions"
               target="_blank">
                <div>
                    <i class="icon-location m-r-2 p-l-1"
                       [style.font-size.rem]="1"></i>
                    <span class="p1"
                          translate>Get directions</span>
                </div>
                <i class="icon-share p-l-1 center"
                   [style.font-size.rem]="1"></i>
            </a>
        </div>
    </div>
    <!-- Schedule-->
    <div class="b-b p-t-7 p-b-7">
        @for (day of weeklySchedule; track day) {
        <div class="flex flex-justify-between p-b-1 p-t-2">
            <p class="p1">{{day.date | date :'EEEE'}}</p>
            @switch (day.status) {
            @case (1) {
            <p class="p1 col-12 uppercase">{{ day.open | hourFormat12 : '' }} - {{ day.close | hourFormat12 : ''
                }}
            </p>
            }
            @case (2) {
            <p class="p1 col-12"
               translate>Closed</p>
            }
            }
        </div>
        }
    </div>
    <!-- Features-->
    @if (store.data.tags) {
    <div class="p-t-7">
        <p class="s1"
           translate>Features</p>
        <div class="p-t-4 flex flex-wrap">
            @for (tag of store.data.tags; track tag) {
            <div class="flex p-r-5 flex-top p-b-2">
                <div class="ratio-1-1"
                     style="width: 20px;">
                    <img class="rf"
                         [image]="asLocalTag(tag).tag_icon">
                </div>
                <span class="p1 p-l-1">{{tag.tag_name}}</span>
            </div>
            }
        </div>
    </div>
    }
</div>
}
